import { Component, Output, EventEmitter, Input, input, model, signal, effect, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlsModule } from '@pmis3/ui-controls';
import { IOrganizationEdit, IOrganizationTypeOrganization } from '@pmis3/master-data-core';
import { IconsModule } from '@progress/kendo-angular-icons';
import { VesselVisitDetailOrganizationPickerComponent } from './vessel-visit-detail-organization-picker/vessel-visit-detail-organization-picker.component';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { Store } from '@ngrx/store';
import { selectOrganizations, selectOrganizationTypes } from '@pmis3/vessel-activity-core';

@Component({
    selector: 'pmis3-vessel-visit-detail-organization',
    standalone: true,
    imports: [CommonModule, ControlsModule, IconsModule, VesselVisitDetailOrganizationPickerComponent, KENDO_BUTTONS],
    templateUrl: 'vessel-visit-detail-organization.component.html',
    styleUrl: "vessel-visit-detail-organization.component.css"
})
export class VesselVisitDetailOrganizationComponent {
    readonly = input(false);
    disabled = input(false);
    // isVesselStopOrgPicker = input(false);

    @Output() assignedOrganization = new EventEmitter<IOrganizationEdit>();
    @Output() deletedOrganization = new EventEmitter<IOrganizationEdit>();

    showDialog = signal<boolean>(false);

    organization = model<IOrganizationEdit | undefined>(undefined);
    get displayOrganizationInfo() {
        return this.organization()
    } 

    organizationTypes = this.store.selectSignal(selectOrganizationTypes);
    organizationTypeName = computed(() => this.organizationTypes()?.find(type => this.organization()?.organizationTypeId == type.organizationTypeId)?.organizationTypeName);
    organizations = this.store.selectSignal(selectOrganizations);
    organizationName = computed(() => this.organizations()?.find(org => this.organization()?.organizationId == org.id)?.name);

    onOrganizationFromChild(org: IOrganizationEdit) {
        if (this.organization())
            this.organization.set(org);
        this.assignedOrganization.emit(org);
    }

    onDeleteOrganization() {
        const organization = {
            ...this.organization(),
            isDeleted: true
        } as IOrganizationEdit;
        this.deletedOrganization.emit(organization)
        this.organization.set(undefined)
    }

    toggleShowDialog() {
        this.showDialog.set(!this.showDialog());
    }

    constructor(private store: Store<any>) {
    }
}